import { View, useWindowDimensions } from "react-native";
import React, { useState } from "react";
import MapView from "react-native-web-maps";
import { hubLocations } from "../../hublocations";
import { Actionsheet } from "native-base";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Text } from "native-base";
const locations = hubLocations;

const HubMap = () => {
  const { width, height } = useWindowDimensions();

  const [activeLocation, setActiveLocation] = useState<(typeof locations)[0]>();

  return (
    <View
      style={{
        width: width,
        height: height,
      }}
    >
      <MapView
        initialRegion={{
          latitude: 8.8857,
          longitude: 7.1462,
        }}
        defaultZoom={6}
        options={{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
        }}
      >
        {locations?.map((l, i) => (
          <MapView.Marker
            key={i}
            title={l.Name}
            description={l["Town"] + " " + l.LGA + " " + l.State}
            coordinate={{ latitude: l.Latitude, longitude: l.Longitude }}
            onPress={() => {
              setActiveLocation(l);
            }}
          ></MapView.Marker>
        ))}
      </MapView>

      <Actionsheet
        isOpen={!!activeLocation?.Name}
        onClose={() => setActiveLocation(null)}
      >
        <View
          style={{
            backgroundColor: "#1f4d1f",
            width: "100%",
            padding: 15,
            paddingTop: 20,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <View
            style={{
              width: 70,
              height: 70,
              marginRight: 20,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 50,
              backgroundColor: "#ddd",
            }}
          >
            <MaterialCommunityIcons
              name="map-marker"
              size={30}
              color={"#333"}
            />
          </View>
          <View style={{ flex: 1 }}>
            <View style={{ flexDirection: "row" }}>
              <Text
                color={"#fff"}
                style={{ fontWeight: "bold", marginRight: 10 }}
              >
                Hub name:
              </Text>
              <Text color={"#fff"}>{activeLocation?.Name}</Text>
            </View>
            <View style={{ flexDirection: "row" }}>
              <Text
                color={"#fff"}
                style={{ fontWeight: "bold", marginRight: 10 }}
              >
                LGA:
              </Text>
              <Text color={"#fff"}>{activeLocation?.LGA}</Text>
            </View>
            <View style={{ flexDirection: "row" }}>
              <Text
                color={"#fff"}
                style={{ fontWeight: "bold", marginRight: 10 }}
              >
                State:
              </Text>
              <Text color={"#fff"}>{activeLocation?.State}</Text>
            </View>
          </View>
        </View>
      </Actionsheet>
    </View>
  );
};

export default HubMap;
